export default __webpack_public_path__ + "static/media/Belt of Bedlam.544accd1.jpg";